import { Injectable } from '@angular/core';
import { Lookup } from '@common/utilities/Lookup';
import { DataService, PartnerRecord } from './data.service';
import { SynchronizationService } from './synchronization.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PartnersService {

  private lookupById = new Lookup<PartnerRecord>(i => i.ID);
  private lookupByName = new Lookup<PartnerRecord>(i => i.Name);

  private _sync(notify = true) {

    if (notify) this.sync.notify(PartnersService, false);

    this.ds.partners('list').subscribe(partners => {

      if (partners) {
        this.lookupById.source = partners;
        this.lookupByName.source = partners;

        this.sync.notify(PartnersService, true);
      }
      else {
        if (this.api.authorized) {
          this._sync(false);
        }
        else {
          this.api.credentialChanged.subscribe(user => {
            this._sync(false);
          });
        }
      }
    });
  }

  public synchronize() {
    this._sync();
  }

  private clone(partner: PartnerRecord): PartnerRecord {
    return partner ? { ...partner } : null;
  }

  public get(idOrName: number | string): PartnerRecord {

    switch (typeof idOrName) {
      case 'string': return this.clone(this.lookupByName.get(idOrName, null));
      case 'number': return this.clone(this.lookupById.get(idOrName, null));
    }
    
  }

  public get all(): PartnerRecord[] {
    return this.lookupById.source.map(i => this.clone(i));
  }

  constructor(private ds: DataService, private api: ApiService, private sync: SynchronizationService) {
    this._sync();
  }
}
